import axios from 'axios'
import { apiConfigAuthenticated } from '@/api/config'

/**
 *  Методы для работы с привязками шаблона к объекту.
 */

export let apiGetBindingsTemplateToObject = function (token) {
  return axios.get('/api/v0/statistic/pages/',
    apiConfigAuthenticated(token))
}

export let apiCreateBindingTemplateToObject = function (data, token) {
  return axios.post('/api/v0/statistic/pages/',
    data,
    apiConfigAuthenticated(token))
}

export let apiEditBindingTemplateToObject = function (id, data, token) {
  return axios.patch(`/api/v0/statistic/pages/${id}/`,
    data,
    apiConfigAuthenticated(token))
}

export let apiDeleteBindingTemplateToObject = function (id, token) {
  return axios.delete(`/api/v0/statistic/pages/${id}/`,
    apiConfigAuthenticated(token))
}



// WEBPACK FOOTER //
// ./src/api/bindings.js